var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "M1.333 2.326c0-.647 0-.971.135-1.15A.67.67 0 0 1 1.96.914c.224-.013.493.167 1.032.526l7.01 4.673c.445.297.668.445.745.632a.67.67 0 0 1 0 .511c-.077.187-.3.336-.745.632l-7.01 4.674c-.54.359-.808.539-1.032.525a.67.67 0 0 1-.492-.263c-.135-.178-.135-.502-.135-1.15z"
  })));
};
export default SvgPlay;